// extracted by mini-css-extract-plugin
export default {"glassEffect":"AccountConfiguration_glassEffect__8xtMS"};